/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { CheckedIcon, TemTag, Text } from "src/shared"
import { formatDate } from "src/utils/formatDate"
import { GiftSelectOption } from "."

interface GiftSelectItemProps {
  data: GiftSelectOption
  disabled?: boolean
  isChecked?: boolean
}

const GiftSelectItem = ({
  data,
  disabled,
  isChecked = false,
}: GiftSelectItemProps) => {
  return (
    <Grid
      flexWrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
      container
    >
      <Grid item>
        <Grid
          rowGap={1}
          columnGap={2}
          container
          justifyItems="center"
          flexWrap="nowrap"
          sx={{
            [theme.breakpoints.down(490)]: {
              columnGap: 1,
              "& > img": {
                width: 50,
                height: 50,
              },
              "& p": {
                fontSize: 13,
                lineHeight: "18px",
              },
            },
            "& p": {
              wordBreak: "break-word",
              whiteSpace: "initial",
            },
          }}
        >
          <img
            width={80}
            height={80}
            src={`${process.env.REACT_APP_IMAGE_URL}/${data.ProductDefaultImage}`}
            alt={data.ProductName}
          />
          <Box>
            <TemTag disabled={disabled} temCount={data.TemQuantity || 0} />
            <Text
              mt={2}
              lineHeight="21px"
              color={theme.palette.common.black}
              fontSize={16}
            >
              {data.ProductName}
            </Text>
            <Text
              lineHeight="21px"
              color={theme.palette.grey[400]}
              fontSize={14}
            >
              Sử dụng đến ngày {formatDate(data.ExpiredDate, "DD/MM/YYYY")}
            </Text>
          </Box>
        </Grid>
      </Grid>
      <Grid item>
        <CheckedIcon
          sx={{
            "& circle": {
              fill: isChecked
                ? theme.palette.info.main
                : theme.palette.grey[400],
            },
          }}
        />
      </Grid>
    </Grid>
  )
}

export default GiftSelectItem
